import {
  IcnAlert,
  IcnBell,
  IcnBookmark,
  IcnCalendar,
  IcnComment,
  IcnDoc,
  IcnHeart,
  IcnMail,
  IcnShield,
  IcnSparkle,
  IcnUser,
  IconButton,
} from '@viquard/doc-ui';
import type { MouseEvent, ReactNode } from 'react';

export interface NotificationKindIconProps {
  kind: string;
  size?: number;
}

export function NotificationKindIcon({ kind, size = 16 }: NotificationKindIconProps): ReactNode {
  const icon =
    kind.startsWith('comment.')
      ? <IcnComment size={size} />
      : kind.startsWith('bookmark.')
        ? <IcnBookmark size={size} />
        : kind.startsWith('article.reaction')
          ? <IcnHeart size={size} />
          : kind.startsWith('annotation.')
            ? <IcnAlert size={size} />
            : kind.startsWith('user.password-reset') || kind.startsWith('user.child-password-reset')
              ? <IcnShield size={size} />
              : kind.startsWith('calendar.') || kind.startsWith('booking.')
                ? <IcnCalendar size={size} />
                : kind.startsWith('coordination.')
                  ? <IcnSparkle size={size} />
                  : kind.startsWith('forum.') || kind.startsWith('survey.')
                    ? <IcnDoc size={size} />
                    : kind.startsWith('newsletter.')
                      ? <IcnMail size={size} />
                      : kind.startsWith('group.')
                        ? <IcnUser size={size} />
                        : <IcnBell size={size} />;
  return (
    <span
      aria-hidden
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size + 8,
        height: size + 8,
        color: 'var(--vq-ink-2)',
      }}
    >
      {icon}
    </span>
  );
}

export function NotificationIconAction(props: {
  label: string;
  disabled?: boolean;
  onClick: () => void;
  children: ReactNode;
}): ReactNode {
  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    props.onClick();
  };

  return (
    <IconButton
      size="sm"
      variant="ghost"
      label={props.label}
      disabled={props.disabled}
      onClick={handleClick}
    >
      {props.children}
    </IconButton>
  );
}
